import PropTypes from 'prop-types';
import React, { useState } from 'react';

const AmenitiesAccordion = ({ tableData }) => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const handleAccordionToggle = idx => {
    setOpenAccordion(openAccordion === idx ? null : idx);
  };

  return (
    <div className="md:hidden px-2 py-4">
      {tableData.length === 0 ? (
        <div className="text-center text-gray-500">No hay reservaciones.</div>
      ) : (
        tableData.map((p, idx) => {
          const key = p.id ? `row-${p.id}` : `row-${idx}`;
          let statusIndicator;
          let statusText;
          if (p.status === 0) {
            statusIndicator = <span className="p-2 bg-warning rounded-circle d-inline-block ms-3"></span>;
            statusText = 'Pendiente';
          } else {
            statusIndicator = <span className="p-2 bg-success rounded-circle d-inline-block ms-3"></span>;
            statusText = 'Agendado';
          }

          return (
            <div key={key} className="mb-4 border rounded-lg bg-white shadow">
              <button
                className="w-full flex flex-row items-center px-4 py-3 focus:outline-none gap-2"
                onClick={() => handleAccordionToggle(idx)}
              >
                <div className="flex flex-1 font-semibold text-primary-500 text-left items-center justify-between">
                  <span>{p.type}</span>
                  <span>{statusIndicator}</span>
                </div>
                <div className="flex items-center justify-center" style={{ width: '32px', height: '32px' }}>
                  <svg
                    className="w-4 h-4 transition-transform duration-200"
                    style={{ transform: openAccordion === idx ? 'rotate(180deg)' : 'rotate(0deg)' }}
                    fill="none"
                    stroke="#253858"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>
              {openAccordion === idx && (
                <div className="px-4 pb-4 pt-2 text-sm text-gray-700 border-t">
                  <div className="mb-2 flex justify-between items-center">
                    <span className="font-medium">Estatus:</span>
                    <span className="flex items-center gap-2">
                      {statusText}
                      {statusIndicator}
                    </span>
                  </div>
                  <div className="mb-2 flex justify-between">
                    <span className="font-medium">Amenidad:</span>
                    <span>{p.type}</span>
                  </div>
                  <div className="mb-2 flex justify-between">
                    <span className="font-medium">Fecha:</span>
                    <span>{p.createdDate}</span>
                  </div>
                  <div className="mb-2 flex justify-between items-center">
                    <span className="font-medium">Hora:</span>
                    <span>{p.hour}</span>
                  </div>
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

AmenitiesAccordion.propTypes = {
  tableData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    status: PropTypes.number,
    type: PropTypes.string.isRequired,
    createdDate: PropTypes.string.isRequired
  })).isRequired
};

export default AmenitiesAccordion;
